<flo-category-list
  [type]="type"
  [adConfigMap]="adConfigMap"
  [categories]="athletes$ | async"
  (searchChange)="updateSearch($event)"
  (showMoreCategories)="fetchAthletes.next()"
></flo-category-list>

